import m, { forwardRef as A } from "react";
import I from "classnames";
import a from "./index48.mjs";
import { View as T } from "./index49.mjs";
import { FLEX_BASE_CLASS as s, FLEX_ALIGN_CONTENT as f, FLEX_ALIGN_ITEMS as R, FLEX_DIRECTION as X, FLEX_JUSTIFY_CONTENT as p, FLEX_WRAP as C } from "./index50.mjs";
import { VIEW_RENDER_AS as S } from "./index51.mjs";
const O = A(
  ({
    alignContent: e = f.NORMAL,
    alignItems: E = R.FLEX_START,
    as: t = S.DIV,
    children: _,
    classes: r = "",
    direction: L = X.ROW,
    gap: o = "0",
    justifyContent: i = p.NORMAL,
    style: N,
    wrap: n = C.NO_WRAP,
    ...l
  }, F) => /* @__PURE__ */ m.createElement(
    T,
    {
      as: t,
      classes: I([
        a[s],
        a[`${s}--gap-${o}`],
        r
      ]),
      style: {
        ...N,
        flexDirection: L,
        justifyContent: i,
        alignItems: E,
        alignContent: e,
        flexWrap: n
      },
      ref: F,
      ...l
    },
    _
  )
);
O.displayName = "Flex";
export {
  f as FLEX_ALIGN_CONTENT,
  R as FLEX_ALIGN_ITEMS,
  s as FLEX_BASE_CLASS,
  X as FLEX_DIRECTION,
  p as FLEX_JUSTIFY_CONTENT,
  C as FLEX_WRAP,
  O as Flex,
  O as default
};
